import axios from 'axios';
import { checkStatus, parseJSON } from '@rsos/utils';
import { getAPIHost } from '@rsos/utils/metaTags';
import serializeRequestError from '@rsos/utils/serializeRequestError';
import fetchRetry from '../fetchRetry';
import { store } from '../store';
import {
  FETCH_INTEGRATIONS_START,
  FETCH_INTEGRATIONS_SUCCESS,
  FETCH_INTEGRATIONS_ERROR,
} from './actionTypes';

const host = `${getAPIHost()}/v1/capstone`;

const instance = axios.create({
  baseURL: `${host}`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const fetchIntegrationAction = (psap_name, token) => dispatch => {
  instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  dispatch({ type: FETCH_INTEGRATIONS_START });

  const { currentPSAP } = store.getState().psaps;
  const { account_id, display_name } = currentPSAP;
  let gspxAccountInfo = {
    id: account_id,
    name: display_name,
  };

  return fetchRetry(`${host}/psaps/${psap_name}/integrations`)
    .then(checkStatus)
    .then(parseJSON)
    .then(response => {
      const updatedResponse = response.map(integration => {
        integration.apisData = [];
        integration.apis.map((item, idx) => {
          gspxAccountInfo[`integration${idx}`] = item;
          integration.apisData.push({
            name: item,
            error: null,
            status: null,
            statusCode: null,
          });
        });

        return integration;
      });

      return dispatch({
        type: FETCH_INTEGRATIONS_SUCCESS,
        payload: updatedResponse,
      });
    })
    .catch(async error => {
      const serializedError = await serializeRequestError(error);
      return dispatch({
        type: FETCH_INTEGRATIONS_ERROR,
        payload: serializedError,
      });
    });
};
